/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=6f7c37c1"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6f7c37c1&lang=css"

import exportComponent from "D:\\vueproject\\phpshareh5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__